<template>
  <div>
    <div id="popupMask" class="popup_mask"></div>
    <modal name="postCodePopup" :width="920" :height="645" :clickToClose="false" @before-open="beforeOpen" @opened="opened">
      <div id="pop_up" class="popup">
        <div class="pop_tit">
          <span>우편번호검색</span>
          <a href="javascript:void(0);" title="close" class="pop_close" @click="close">close</a>
        </div>
        <div class="pop_con_wrap">
          <div class="pop_con mscroll" style="height: 500px;">
            <div class="pop_con_bg">
                  <div ref="wrap" style="display:block;border:0px solid;width:100%;height:100%;margin:5px 0;position:relative">
                    <!-- <VueDaumPostcode  @complete="onComplete" /> -->
                  </div>
            </div>
          </div>
        </div>
        <div class="pop_footer_wrap">
          <div class="pop_btn_area">
            <button class="btn_type_01 delete" @click="close" >닫기</button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
//import { VueDaumPostcode } from 'vue-daum-postcode'

const $ = window.$

export default {
  name: 'PostCodePopup',
  components: {
    //VueDaumPostcode
  },
  mounted () {
    // if (!window.daum) {
    //   const script = document.createElement('script')
    //   script.src = process.env.KAKAO_POSTCODE_URL
    //   document.head.appendChild(script)
    // }

    if (window.kakao && window.kakao.maps) {
      this.initMap()
    } else {
      const script = document.createElement('script')
      // eslint-disable-next-line no-undef
      script.onload = () => window.kakao.maps.load(this.initMap)
      script.src = process.env.KAKAO_MAPS_URL + '?autoload=false&appkey=' + process.env.KAKAO_MAP_APPKEY + '&libraries=services'
      document.head.appendChild(script)
    }
  },
  watch: {

  },
  methods: {
    initMap () {
      const mapContainer = document.getElementById('map')
      const mapOption = {
        center: new window.kakao.maps.LatLng(37.564343, 126.947613),
        level: 5
      }

      this.map = new window.kakao.maps.Map(mapContainer, mapOption)
    },
    beforeOpen (e) {
      console.log(e)
    },
    opened (e) {
      var popLeft = 0
      var popTop = 0

      $('#popupMask').fadeIn()
      $('#pop_up').css({'left': popLeft, 'top': popTop}).fadeIn().addClass('on')


    },
    onComplete (data) {
      var addr = ''
      var fullAddr = ''
      var extraAddr = ''

      if (data.userSelectedType === 'R') {
        addr = data.roadAddress

        if (data.bname !== '') {
          extraAddr += data.bname
        }

        if (data.buildingName !== '') {
          extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName)
        }
        extraAddr += (extraAddr !== '' ? ' (' + extraAddr + ')' : '')
      } else {
        addr = data.jibunAddress
      }

      fullAddr = addr

      const me = this
      const geocoder = new window.kakao.maps.services.Geocoder()
      geocoder.addressSearch(fullAddr, function (result, status) {
        console.log('status=' + status)

        if (status === window.kakao.maps.services.Status.OK) {
          me.$emit('popup-complete', {
            postNum: data.zonecode,
            inslAddr: addr,
            dtlAddr: extraAddr,
            sidoNm: data.sido,
            sigunguNm: data.sigungu,
            atmLtdVal: result[0].x,
            atmLngtVal: result[0].y
          })

          console.log('kakao.maps.services.Status.OK')
          me.close()
        } else {
          console.log('kakao.maps.services.Status.FAIL')
          me.close()
        }
      })
    },
    closed () {
      $('#pop_up').fadeOut().removeClass('on')
      $('#popupMask').fadeOut()

      this.uploadExcelFileName = ''
    },
    close () {
      this.closed()
      this.$modal.hide('postCodePopup')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/purchase/cmm/PostCodePopup.vue